import React, { useCallback, useEffect, useRef, useMemo, useState } from 'react'
import { useResizeDetector } from 'react-resize-detector'
import { LazyMotion, m, domAnimation } from 'framer-motion'
import Context from './Context'

export default function AnimateAutoHeight({ duration, children }) {
  const disabled = useRef(false)
  const prevDisabled = useRef(false)
  const animationFrame = useRef(null)
  const [layoutVersion, setLayoutVersion] = useState(0)
  const [animationsDisabled, setAnimationsDisabled] = useState(false)

  const onResize = useCallback(
    () => {
      if (animationFrame.current !== null) return
      animationFrame.current = window.requestAnimationFrame(() => {
        animationFrame.current = null
        setLayoutVersion(version => version + 1)
      })
    },
    [setLayoutVersion]
  )

  useEffect(() => {
    return () => {
      if (animationFrame.current !== null) {
        window.cancelAnimationFrame(animationFrame.current)
      }
    }
  }, [])

  const contextValue = useMemo(
    () => {
      return {
        disableAnimations: () => {
          prevDisabled.current = disabled.current
          disabled.current = true
          setAnimationsDisabled(true)
        },
        restoreAnimationState: () => {
          disabled.current = prevDisabled.current || false
          prevDisabled.current = null
          setAnimationsDisabled(disabled.current)
        },
      }
    },
    [setAnimationsDisabled]
  )

  const { ref } = useResizeDetector({
    handleHeight: true,
    handleWidth: false,
    onResize,
    // HACK (jscheel): https://github.com/maslianok/react-resize-detector/issues/45
    refreshMode: 'debounce',
    refreshRate: 0,
    // END HACK
  })

  return (
    <Context.Provider value={contextValue}>
      <LazyMotion features={domAnimation}>
        <m.div
          layout={!animationsDisabled}
          layoutDependency={layoutVersion}
          initial={false}
          transition={{
            layout: { type: 'spring', duration: duration / 1000, bounce: 0 },
          }}
          style={{ overflow: 'hidden' }}
        >
          <div ref={ref}>{children}</div>
        </m.div>
      </LazyMotion>
    </Context.Provider>
  )
}
